"use client";
import React, { useEffect } from "react";
import { useAppLayerContext } from "@/shared/contexts/AppLayer";
import VariantPetStepHero from "./VariantPetStepHero";
import HowSpotWorks from "./HowSpotWorks";

export default function SimplifiLifestyle() {
    const { updateAppState } = useAppLayerContext();

    useEffect(() => {
        updateAppState({ retargetingCardImage: "dogChasing" });
        return () => {
            updateAppState({ retargetingCardImage: undefined });
        };
    }, [updateAppState]);

    return (
        <div className="lg:mt-[-155px] xl:mt-[-140px]">
            <VariantPetStepHero variant="whySpot" simplifiVariant="lifestyle" bottomSlot={<HowSpotWorks />} />
        </div>
    );
}
